import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { ReactNode } from "react";
import { WfTierWordmark } from "@WahooFitness/redesignr";
import type { SubscriptionDisplayData } from "./useTieredMembership";

interface SubscriptionCardProps {
  subscriptionData: SubscriptionDisplayData | null | undefined;
}

function SubscriptionCard({ subscriptionData }: SubscriptionCardProps) {
  const tier = subscriptionData?.tier;
  return (
    <Box width="100%" maxWidth="sm">
      <Box bgcolor="secondary.light" borderRadius={1.5} px={1}>
        <Stack
          direction="row"
          gap={2}
          justifyContent="space-between"
          py={1.25}
          px={1}
          alignItems="center"
        >
          {tier && <WfTierWordmark tier={tier} />}
          {subscriptionData?.tag}
        </Stack>
        <Divider />
        <List disablePadding>
          {subscriptionData?.items.map(
            (item: { label: string; value: string | ReactNode }, index: number) => {
              return (
                <ListItem
                  key={index}
                  disablePadding
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingY: 1.5,
                    gap: 1,
                    alignItems: "flex-start",
                  }}
                >
                  <Typography variant="prose-sm" sx={{ whiteSpace: "nowrap", px: 1 }}>
                    {item.label}
                  </Typography>
                  <Typography
                    variant="prose-sm-bold"
                    sx={{ wordBreak: "break-word", textAlign: "right", px: 1 }}
                  >
                    {item.value}
                  </Typography>
                </ListItem>
              );
            }
          )}
        </List>
        {subscriptionData?.footerNote && (
          <Box px={1} sx={{ paddingY: 1.5 }}>
            {subscriptionData.footerNote}
          </Box>
        )}
      </Box>
    </Box>
  );
}
export default SubscriptionCard;
